// Base mobule
export { default as Load } from './modules/Load';
export { default as Scroll } from './modules/Scroll';
export { default as ClassToggle } from './modules/ClassToggle';
// export { default as Navs } from './modules/Navs';
// Accordion
export { default as Accordion } from './modules/Accordion';
// Nav Anchors
export { default as NavAnchors } from './modules/NavAnchors';
export { default as NavAnchorsNew } from './modules/NavAnchorsNew';
// Nav Panels
export { default as NavPanels } from './modules/NavPanels';
// Accessibility Navigation
export { default as Accessibility } from './modules/Accessibility';
// Focus management
export { default as SetFocus } from './modules/SetFocus';
// Tabs
export { default as Tabs } from './modules/Tabs';
// Overlay
export { default as Overlay } from './modules/Overlay';
export { default as OverlayClose } from './modules/OverlayClose';
// Lightbox
export {default as GLightbox} from './modules/GLightbox';
// Gutenberg Figcaption
export {default as Figcaption} from './modules/Figcaption';
// Mouse Cursor (follow mouse)
export {default as MouseCursor} from './modules/MouseCursor';
// BrasFort Slider
export { default as Slider } from './modules/Slider';
// BrasFort Slider
export { default as VideoPlayer } from './modules/VideoPlayer';
// File input Label
export {default as FileLabel} from './modules/FileLabel';
// Legacy Tooltip from old blog
export {default as LegacyTooltip} from './modules/LegacyTooltip';
// Form validation
// export { default as FormValidation } from './modules/FormValidation';
// Scroll Direction Class
// export {default as ScrollDirection} from './modules/ScrollDirection';
export {default as Calculator} from './modules/Calculator';
export {default as Search} from './modules/Search';
export {default as BlogSearch} from './modules/BlogSearch';
export {default as EvenementSearch} from './modules/EvenementSearch';
export {default as BourseSearch} from './modules/BourseSearch';
export {default as ProjectSearch} from './modules/ProjectSearch';
export {default as ProgrammeSearch} from './modules/ProgrammeSearch';
export {default as EquipmentSearch} from './modules/EquipmentSearch';
export {default as ClubSearch} from './modules/ClubSearch';
export {default as CoursSearch} from './modules/CoursSearch';
export {default as ProfSearch} from './modules/ProfSearch';
export {default as Stats} from './modules/Stats';
export {default as CallModule} from './modules/CallModule';
export {default as ButtonStickyHeader} from './modules/ButtonStickyHeader';
export {default as CoursesListing} from './modules/CoursesListing';
export {default as AdmissionAccordions} from './modules/AdmissionAccordions';
export {default as AdmissionV2} from './modules/AdmissionV2';
export {default as ConditionsAdmission} from './modules/ConditionsAdmission';
export {default as DynamicContentSelector} from './modules/DynamicContentSelector';
export {default as ContactBox} from './modules/ContactBox';
// export { default as FlexibleForms } from './modules/FlexibleForms';
export { default as FlexibleFormsV2 } from './modules/FlexibleFormsV2';
export { default as FoldVideo } from './modules/FoldVideo';
export { default as FoldVideoControl } from './modules/FoldVideoControl';
export { default as PersonnesRessources } from './modules/PersonnesRessources';
export { default as PersonnesRH } from './modules/PersonnesRH';
export { default as PeopleTooltip } from './modules/PeopleTooltip';
export { default as Alert } from './modules/Alert';
export { default as CookieConsent } from './modules/CookieConsent';
export { default as Comments } from './modules/Comments';
export { default as Equivalence } from './modules/Equivalence';
export { default as EvenementsList } from './modules/EvenementsList';
export { default as IcsResolver } from './modules/IcsResolver';
